import { getApiServerUrl } from '../../UM-Base/lib/TripPlannerHelper';

let apiHubUrl = '';
apiHubUrl = getApiServerUrl();


async function deleteRemoteFave(token, productId) {

	// um-api-hub-test.azurewebsites.net/api/Bookmark/delete/?id={productId}
	// apihub-test.southaustralia.com/api/Bookmark
	const url = `${apiHubUrl}/api/bookmark/delete/${productId}`;

	let myHeaders = new Headers({
		'accept': '*/*',
		'Authorization': token,
		'Content-Type': 'application/json'
	});

	// let remoteFavesData =
	await fetch(url, {
		method: "DELETE",
		headers: myHeaders,
	}).then(res => {
		// console.log("Request response:", res);
		// console.log("res status:", res.status);
		if (res && res.status != 200) {
			console.error("Request not 200. Response:", res);
		} else {
			console.log("Success. Response raw: ", res);
			// console.log("Response as json: ", res.json());
			// return res.json(); // translate response stream to JSON
		}
		// }).then(data => {
		// console.log('bookmarks on remote: ', data);
		// return data;
	}).catch(error => {
		console.error('POST failed: ', error);
		if (error.status == 401) {
			console.error("Unauthorized response status code: ", error.status);
			//TODO: this.signOut();  // logoutLocal and close modal
		}
	});

	// return remoteFavesData;

}


function setRemoteFaves(token, favesToAdd) {
	// run a remoteAPIAddFave(); method
	favesToAdd = JSON.stringify(favesToAdd);
	let favesToAddString = favesToAdd.replace(/,/g, '-').replace(/[^a-zA-Z0-9\-]/g, '');

	// apihub-test.southaustralia.com/api/Bookmark
	const url = `${apiHubUrl}/api/bookmark?id=${favesToAddString}`;

	let myHeaders = new Headers({
		'accept': '*/*',
		'Authorization': token,
		'Content-Type': 'application/json'
	});

	// Return the promise so callers can await the outcome. Resolves true only on a
	// successful (2xx) response, false on a non-OK status or network error. Callers that
	// don't await (e.g. the per-product heart buttons) still work as fire-and-forget.
	return fetch(url, {
		method: "POST",
		headers: myHeaders,
		// body: favesToAddRemote   // this api endpoint expects product id's via a query string.
	}).then(res => {
		if (res && res.ok) {
			return true;
		}
		console.error("Request not 200. Response:", res);
		return false;
	}).catch(error => {
		console.error('POST failed: ', error);
		if (error && error.status == 401) {
			console.error("Unauthorized response status code: ", error.status);
			//TODO: this.signOut();  // logoutLocal and close modal
		}
		return false;
	});

}

async function sendWishListEmail(token, data) {
	try {
		const url = `${apiHubUrl}/api/submit-selections`;

		let myHeaders = new Headers({
			'accept': '*/*',
			'Authorization': token,
			'Content-Type': 'application/json'
		});

		const response = await fetch(url, {
			method: 'POST',
			headers: myHeaders,
			body: JSON.stringify(data)
		});
		return response.ok;
	} catch (error) {
		console.error('API call failed:', error);
		return false;
	}
}


async function getRemoteFaves(token) {

	// let favesToAddLocal = localStorage.getItem('favourites');
	// let favesToAddRemote = favesToAddLocal.replace(/,/g, '-').replace(/[^a-zA-Z0-9\-]/g, '');

	// apihub-test.southaustralia.com/api/Bookmark
	const url = `${apiHubUrl}/api/bookmark`;

	let myHeaders = new Headers({
		'accept': '*/*',
		'Authorization': token,
		'Content-Type': 'application/json'
	});

	// let testRequest = {
	//   url: url,
	//   token: token
	// }
	// console.log('testRequest: ', testRequest);

	let remoteFavesData = await fetch(url, {
		method: "GET",
		headers: myHeaders,
		// body: favesToAddRemote   // this api endpoint expects product id's via a query string.
	}).then(res => {
		// console.log("Request response:", res);
		// console.log("res status:", res.status);
		if (res && res.status != 200) {
			console.error("Request not 200. Response:", res);
		} else {
			return res.json(); // translate response stream to JSON
		}
	}).then(data => {
		// console.log('bookmarks on remote: ', data);
		return data;
	}).catch(error => {
		console.error('POST failed: ', error);
		if (error.status == 401) {
			console.error("Unauthorized response status code: ", error.status);
			//TODO: this.signOut();  // logoutLocal and close modal
		}
	});

	return remoteFavesData;

}


export { deleteRemoteFave, getRemoteFaves, setRemoteFaves };
